import {
  AUTH_ERROR,
  AUTH_LOADING,
  LOG_OUT,
  RESET_AUTH,
  STOP_AUTH_LOADING,
  SUCCESS_LOGIN,
  CHECKING_LOGIN,
} from "../../const/actionTypes";

interface IInitialState {
  loggedIn: boolean;
  token?: string;
  loading: boolean;
}

let token = localStorage.getItem("enterprise_portal_access_Token");

const initialState: IInitialState = token
  ? { loggedIn: true, token, loading: false }
  : { loading: false, loggedIn: false, token: "" };

export type AuthState = Readonly<typeof initialState>;

const authReducer = (state = initialState, action: any): AuthState => {
  switch (action.type) {
    case AUTH_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }

    case SUCCESS_LOGIN: {
      localStorage.setItem(
        "enterprise_portal_access_Token",
        action.payload.accessToken
      );
      localStorage.setItem(
        "enterprise_portal_refresh_token",
        action.payload.refreshToken
      );
      return {
        ...state,
        loading: false,
        loggedIn: true,
      };
    }

    case CHECKING_LOGIN: {
      return {
        ...state,
        loading: false,
        loggedIn: false,
      };
    }

    case AUTH_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }

    case LOG_OUT: {
      return {
        ...state,
        loggedIn: false,
        loading: false,
      };
    }

    case RESET_AUTH: {
      return {
        ...state,
        loading: false,
        loggedIn: false,
      };
    }

    case STOP_AUTH_LOADING: {
      return {
        ...state,
        loading: false,
      };
    }

    default:
      return state;
  }
};

export default authReducer;
